/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { parseFaults } from 'ng/modules/virtual-service/utils/virtual-service-faults.utils';

/**
 * @ngdoc factory
 * @name  VirtualServiceFaultDataTransformer
 * @description
 *     DataTransformer responsible for adding faults to Virtual Service from the
 *     "virtualservice-inventory" request.
 */
angular.module('aviApp').factory('VirtualServiceFaultDataTransformer', [
'DataTransformer', DataTransformer => {
    return class VirtualServiceFaultDataTransformer extends DataTransformer {
        constructor(args) {
            super(args);
            this.name = 'faults';
        }

        /**
         * @override
         */
        beforeCall(data, groupCall) {
            if (groupCall.inventory) {
                groupCall.inventory.include.faults = true;
            }
        }

        /**
         * @override
         */
        afterCall(data, groupCall) {
            if (groupCall.inventory && groupCall.inventory.response) {
                if (!_.isEmpty(groupCall.inventory.response.faults)) {
                    data.parsedFaults = parseFaults(groupCall.inventory.response.faults);
                }
            }
        }
    };
}]);
